import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";

export type CustomMaterialsDto = ClientInferResponseBody<
  typeof contract.materials.findAllCustomMaterials,
  200
>;
export type Material = CustomMaterialsDto[number];

export const fetchCustomMaterials = async (): Promise<Material[]> => {
  const response = await api.materials.findAllCustomMaterials.query();

  if (response.status === 200) {
    return response.body;
  }

  return [];
};
